export { ContactInfoType } from './generated/ContactInfoType.js';